import { Link } from 'react-router-dom'
import { Cookies } from 'react-cookie';
import { BindReportGrid, ClearSession, exportToExcel } from "../Common/Common";
import { useEffect, useState } from 'react';
import { API_SERVER, initializeFilterData } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import Loader from './Loader';
const cookies = new Cookies();

const Header = ({ setOpen, open }) => {
    let UserName = cookies.get('userName');
    let UserCode = cookies.get('loginUserCode')
    const Token = cookies.get('token')
    const navigate = useNavigate();
    let SalesPersonCode = cookies.get('salesPersonCode')
    let LoginUserCode = cookies.get('loginUserCode');
    const [isLoading, setIsLoading] = useState(false);

    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [SessionClear, setSessionClear] = useState(false);
    const [Record, setRecord] = useState([]);
    const [tableData, setTableData] = useState({})
    const [PageType, setPageType] = useState('');
    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
    });
    const handleSignOut = async () => {
        setSessionClear(true);
    };

    const handleModalOpen = (modalType) => {
        setPageType(modalType);
        setCurrentPageNo(1);
        setFilterData({ PageIndex: "1" });
        getRequisitionData('S', modalType, "1");
    };
    const customStyle = {
        maxWidth: '80%',
    };


    //This is for show bell count
    const fetchData = async () => {
        let Token = cookies.get('token');
        let LoginUserCode = await cookies.get('loginUserCode');
        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');

        } else {

            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = { Token, LoginUserCode };
            post(`${API_SERVER}/api/Dashboard/GetDashboardData`, { ...data }, (responseData) => {
                if (responseData.status === "SUCCESS") {
                    setRecord(responseData);
                }
                else {
                    throw new Error('Error fetching data from API');
                }
            })
        };
    }

    //This is for show Popup data and export

    const getRequisitionData = async (Type = '', Calltype = '', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const type = String(Type)
       
        const data = {
            Type: type, Token, LoginUserCode: loginCodeString, ...FilterData, Calltype: Calltype ? Calltype : PageType, PageIndex: `${PI}`
        }

        setIsLoading(true)
        post(`${API_SERVER}/api/Dashboard/GetDashboardPopupData`, { ...data }, (res) => {
            //setPageType('')
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        const fileName = Calltype || PageType || 'ExportData';
                        exportToExcel(res.Data, fileName);
                    } else {
                        console.error("Data received from API is not an array:", res);
                    }
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData({})
            }
            if (res.message !== "") {
                AlertBox(res.Status, res.message, "");
            }
            setIsLoading(false)
        })
    }

    const handleChange1 = (event, value) => {
        setCurrentPageNo(value);
        setFilterData((prev) => ({
            ...prev,
            PageIndex: value.toString(),
        }));
        getRequisitionData('S', PageType, value);
    };
    useEffect(() => {
       
    }, []);

    useEffect(() => {
        fetchData();
    }, []);
    const toggleFullScreen = () => {
        const elem = document.documentElement;
        if (!document.fullscreenElement) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }
    
    return (
        <>
            <header id="header" className="header fixed-top d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-between">
                    <Link className="logo d-flex align-items-center">
                        <span className="logo">
                            <img src="assets/img/logo.png" alt="" />
                        </span>
                    </Link>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={() => setOpen(!open)} />
                </div>

                <div className="d-flex">
                    <button className="toggle-fullscreen-btn" onClick={toggleFullScreen} style={{ border: "none", backgroundColor: "white" }}>
                        <i className="bi bi-arrows-fullscreen"></i>
                    </button>

                    <nav className="header-nav">

                        <ul className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <li key='abc' className='nav-item' style={{ marginRight: "10px" }}>
                                <span
                                    className="nav-link mt-1 me-2 m-lg-1"
                                    role="button"
                                    aria-expanded="false"
                                    target='_blank'
                                    data-bs-toggle="modal"
                                    data-bs-target="#pendingOrderModal"
                                    title="Pending Customer Order"
                                    onClick={() => {
                                        if (Record.pendingOrder > 0) {
                                            handleModalOpen('PendingCustomerOrder');
                                        }
                                    }}
                                >
                                    <i className="fa-solid fa-bell position-relative" style={{ color: "grey" }}>
                                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill btn-danger"
                                            style={{ fontSize: '9px', color: "white", padding: "2px", backgroundColor: "red" }}>
                                            {Record.pendingOrder}
                                        </span>
                                    </i>
                                </span>

                                <div className="modal fade" id="pendingOrderModal" aria-labelledby="pendingOrderModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered custom-modal-dialog" style={customStyle}>
                                        <div className="modal-content px-3">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="pendingOrderModalLabel">Pending Customer Order</h5>
                                                <div className="lms-new-button text-center" style={{ border: "none" }}>
                                                    <button
                                                        className="button export-btn"
                                                        onClick={() => {
                                                            if (Record.pendingOrder > 0) {
                                                                getRequisitionData('E', 'PendingCustomerOrder', FilterData.PageIndex);
                                                            }
                                                        }}
                                                    >
                                                        <i className="bi bi-download" /> Export
                                                    </button>
                                                    <button type="button" className="btn btn-light" data-bs-dismiss="modal"
                                                        style={{ margin: '-1px', minWidth: '30px' }}>
                                                        <i className="fa-solid fa-xmark" />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="modal-body">
                                                {Record.pendingOrder > 0 ? (
                                                    <BindReportGrid
                                                        tableData={tableData}
                                                        currentPageNo={currentPageNo}
                                                        setFilterData={setFilterData}
                                                        filterData={FilterData}
                                                        handleChange1={handleChange1}
                                                    />
                                                ) : (
                                                        <div className="text-center py-3 text-muted fw-semibold">
                                                            No records found
                                                        </div>
                                                )}
                                                {SessionClear && <ClearSession />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li key='abc1' className='nav-item' style={{ marginRight: "10px" }}>
                                <span
                                    className="nav-link mt-1 me-2 m-lg-1"
                                    role="button"
                                    aria-expanded="false"
                                    data-bs-toggle="modal"
                                    data-bs-target="#pendingReqSheetsModal"
                                    title="Pending Request Sheets"
                                    onClick={() => handleModalOpen('PendingRequestSheets')}
                                >
                                    <i className="fa-solid fa-bell position-relative" style={{ color: "grey" }}>
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill btn-danger"
                                            style={{ fontSize: '9px', color: "white", padding: "2px", backgroundColor: "red" }}
                                        >
                                            {Record.pendingReqSheets || 0}
                                        </span>
                                    </i>
                                </span>

                                <div
                                    className="modal fade"
                                    id="pendingReqSheetsModal"
                                    aria-labelledby="pendingReqSheetsModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered custom-modal-dialog" style={customStyle}>
                                        <div className="modal-content px-3">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="pendingReqSheetsModalLabel">Pending Request Sheets</h5>
                                                <div className="lms-new-button text-center" style={{ border: "none" }}>
                                                    <button
                                                        className="button export-btn"
                                                        onClick={() => {
                                                            if (Record.pendingReqSheets > 0) {
                                                                getRequisitionData('E', 'PendingRequestSheets', FilterData.PageIndex);
                                                            }
                                                        }}
                                                    >
                                                        <i className="bi bi-download" /> Export
                                                    </button>
                                                    <button type="button" className="btn btn-light" data-bs-dismiss="modal" style={{ margin: '-1px', minWidth: '30px' }}>
                                                        <i className="fa-solid fa-xmark" />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="modal-body">
                                                {Record.pendingReqSheets > 0 ? (
                                                    <BindReportGrid
                                                        tableData={tableData}
                                                        currentPageNo={currentPageNo}
                                                        setFilterData={setFilterData}
                                                        filterData={FilterData}
                                                        handleChange1={handleChange1}
                                                    />
                                                ) : (
                                                    <div className="text-center py-3 text-muted fw-semibold">
                                                        No records found
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>
                            <li key='abc2' className='nav-item' style={{ marginRight: "10px" }}>
                                <span className="nav-link mt-1 me-2 m-lg-1" href="#" role="button" aria-expanded="false" target='_blank' data-bs-toggle="modal" data-bs-target="#emptiesItemDetailsModal" title="Empties Item Details">
                                    <i className="fa-solid fa-bell position-relative" style={{ color: "grey" }} onClick={() => {
                                        if (Record.emptiesItemDetails > 0) {
                                            handleModalOpen('EmptiesItemDetail');
                                        }
                                    }}>
                                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill btn-danger" style={{ fontSize: '9px', color: "white", padding: "2px", backgroundColor: "red" }} >
                                            {Record?.emptiesItemDetails || '0'}
                                        </span>
                                    </i>
                                </span>
                                {
                                    Record.emptiesItemDetails > 0 ?
                                        (
                                            <>
                                                <div className="modal fade" id="emptiesItemDetailsModal" aria-labelledby="emptiesItemDetailsModal" aria-hidden="true">
                                                    <div className="modal-dialog modal-dialog-centered custom-modal-dialog" style={customStyle}>
                                                        <div className="modal-content px-3">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="emptiesItemDetailsModal">Empties Item Details</h5>
                                                                <div className="lms-new-button text-center" style={{ border: "none" }}>
                                                                    <button className="button export-btn" onClick={() => {
                                                                        if (Record.emptiesItemDetails > 0) {
                                                                            getRequisitionData('E', 'EmptiesItemDetail', FilterData.PageIndex);
                                                                        }
                                                                    }} >
                                                                        <i className="bi bi-download" /> Export
                                                                    </button>
                                                                    <button type="button" className="btn btn-light" data-bs-dismiss="modal" style={{ margin: '-1px', minWidth: '30px' }}> <i className="fa-solid fa-xmark" /></button>

                                                                </div>
                                                            </div>
                                                            <div className="modal-body">
                                                                <BindReportGrid tableData={tableData}
                                                                    currentPageNo={currentPageNo}
                                                                    setFilterData={setFilterData}
                                                                    filterData={FilterData}
                                                                    handleChange1={handleChange1}

                                                                />

                                                                {SessionClear ? <ClearSession /> : <></>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )

                                        : <></>
                                }
                            </li>
                            <li className="nav-item dropdown pe-3">
                                <button

                                    className="nav-link nav-profile d-flex align-items-center pe-0"
                                    data-bs-toggle="dropdown"
                                    style={{ border: "none", backgroundColor: "white" }}
                                >
                                    <img
                                        src="assets/img/profile-img.Png"
                                        alt="Profile"
                                        className="rounded-circle"
                                    />
                                    <span className="d-none d-md-block dropdown-toggle ps-2">
                                        {`${UserName} (${SalesPersonCode ? SalesPersonCode : UserCode})`}
                                    </span>

                                </button>
                                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                    <li className="dropdown-header content-left-align">
                                        <h6>{UserName}</h6>
                                        <span>UserCode: {SalesPersonCode ? SalesPersonCode : UserCode}</span>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <button className="dropdown-item d-flex align-items-center" onClick={handleSignOut}>
                                            <i className="bi bi-box-arrow-right" />
                                            <span>Sign Out</span>
                                        </button>
                                    </li>
                                </ul>

                            </li>

                        </ul>
                    </nav>
                </div>
            </header>
            {SessionClear ? <ClearSession /> : <></>}
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </>
    )
}
export default Header